import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const StaticDocumentQuery = gql`
    query($domain: String!) {
        staticDocuments(domain: $domain) {
            id
            title
            html
            tags
        }
        languages {
            id
            value
        }
    }
`;

const CreateStaticDocumentMutation = gql`
    mutation($staticDocument: CreateStaticDocumentInput!) {
        createStaticDocument(staticDocument: $staticDocument) {
            id
        }
    }
`;

const UpdateStaticDocumentMutation = gql`
    mutation($id: String!, $staticDocument: UpdateStaticDocumentInput!) {
        updateStaticDocument(id: $id, staticDocument: $staticDocument) {
            id
        }
    }
`;

const DeleteStaticDocumentMutation = gql`
    mutation($id: String!) {
        deleteStaticDocument(id: $id) {
            id
        }
    }
`;

interface IInputProps {
    children?: any;
    domain: string;
}

interface Response {
    data: any;
}

class GetStaticDocumentQuery extends React.Component<ChildProps<IInputProps, Response>, {}> {
    render() {
        const { staticDocuments, createStaticDocument, updateStaticDocument, deleteStaticDocument }: any = this.props;
        return this.props.children({
            staticDocuments,
            createStaticDocument,
            updateStaticDocument,
            deleteStaticDocument
        });
    }
}

export default compose(
    graphql<IInputProps, Response>(StaticDocumentQuery, {
        name: 'staticDocuments',
        options: props => ({
            variables: { domain: props.domain }
        })
    }),
    graphql<IInputProps, Response>(CreateStaticDocumentMutation, {
        name: 'createStaticDocument'
    }),
    graphql<IInputProps, Response>(UpdateStaticDocumentMutation, {
        name: 'updateStaticDocument'
    }),
    graphql<IInputProps, Response>(DeleteStaticDocumentMutation, {
        name: 'deleteStaticDocument'
    })
)(GetStaticDocumentQuery);



// WEBPACK FOOTER //
// ./src/components/Query/StaticDocuments/StaticDocuments.tsx